import styled, { css } from "styled-components";
import { rgbaToHex } from "./PickerAndSelector";

export const ExpirationDateStyle = styled.p`
  ${({ scale, bgColor, color }) => css`
    font-size: ${16 * scale}px;
    background-color: ${color};
    color: ${rgbaToHex(bgColor, 1)};
  `}
  text-transform: uppercase;
  text-align: center;
  margin-top: 0 !important;
  &::first-letter {
    text-transform: uppercase;
  }
  font-weight: bold;
`;
const DateHighlight = styled.span`
  display: inline-block;
  line-height: 1;
  font-weight: 800;
  ${({ bg, color, scale }) => css`
    background-color: ${rgbaToHex(color, 1)};
    color: ${rgbaToHex(bg, 1)};
    font-size: ${25 * scale}px;
    border-radius: ${25 * scale}px;
    padding: ${0.16 * scale}rem ${1 * scale}rem;
    margin: ${0.8 * scale}rem;
  `}
`;

export default function ExpirationDate({
  startDate,
  endDate,
  styles,
  scale,
  className,
}) {
  const startStr = extractDayMonth(startDate);
  const endStr = extractDayMonth(endDate);
  const sameDay = startStr && endStr && startStr === endStr;
  console.log(scale);
  const highlightBg =
    (styles && styles.color) || (styles && styles.txtColor) || "#ffffff";
  const highlightColor = (styles && styles.bgColor) || "#000000";

  const renderDate = (dateStr) =>
    dateStr ? (
      <DateHighlight
        bg={highlightBg}
        color={highlightColor}
        scale={scale}
        className={"date-highlight"}
      >
        {dateStr}
      </DateHighlight>
    ) : null;

  return (
    <ExpirationDateStyle
      scale={scale}
      bgColor={styles && styles.bgColor}
      color={styles && styles.txtColor}
      className={className}
    >
      {startStr && endStr ? (
        <>
          Ofertas válidas a partir do dia {renderDate(startStr)} até o dia{" "}
          {renderDate(endStr)} ou enquanto durarem os estoques
        </>
      ) : startStr ? (
        <>
          Ofertas válidas a partir do dia {renderDate(startStr)} enquanto
          durarem os estoques
        </>
      ) : endStr ? (
        <>
          Ofertas válidas até o dia {renderDate(endStr)} ou enquanto durarem os
          estoques
        </>
      ) : (
        "Ofertas válidas enquanto durarem os estoques"
      )}
    </ExpirationDateStyle>
  );
}

function extractDayMonth(date) {
  if (!date) return;

  const day =
    date.getUTCDate() < 10 ? `0${date.getUTCDate()}` : date.getUTCDate();
  const month =
    date.getUTCMonth() + 1 < 10
      ? `0${date.getUTCMonth() + 1}`
      : date.getUTCMonth() + 1;
  return `${day}/${month}/${date.getUTCFullYear()}`;
}
